var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgColorFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.345 18.687l.518-3.439h-3.242v-2.23c0-.941.453-1.859 1.905-1.859H22V8.232S20.663 8 19.384 8c-2.67 0-4.416 1.647-4.416 4.628v2.621H12v3.438h2.968V27h3.653v-8.313h2.724z",
    fill: "#2E5ECC"
  })));
}

export default SvgColorFb;